
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'

import {
SaafHeader,
SaafFooter,
SaafImageUpload,
} from '@/common/components/index'
import { mapState } from 'vuex'

import service from '@/common/tool/service'
import nativeApi from '@/common/tool/nativeApi'



export default {
data () {
return {
fileList:[]
}
},
components: {
SaafHeader,
SaafFooter,
SaafImageUpload,
XButton,
XInput,
Group,
},
computed: {
...mapState({
userInfo: state => state.user.userInfo,
}),
},
created(){

},
methods: {

},
watch:{
},
mounted(){

},
}




// WEBPACK FOOTER //
// ./src/page/demo/ComponentDemo.vue